import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { TimeType } from "../models/project";

@Injectable({ providedIn: 'root' })
export class TimeTypesService extends BaseService {
      constructor(private http: HttpClient) {
        super();
      }

      fetch() {
        return this.http.get<TimeType[]>(environment.apiUrl + 'timetypes');
      }
}